module.exports = __webpack_public_path__ + "static/media/table-view-green.6a4cdc6c.svg";